import React from 'react';

const Input = ({
    id,
    label,
    onChange,
    placeholder,
    name,
    type = "text",
    className,
    defaultValue,
    value,
    disabled,
    error,
    errorMessage,
    register,

}) => {
    return (
        <div className={`input-box ${className || ""} ${error ? "error" : ""}`}>
            <label htmlFor={id}>{label}</label>
            <input
                type={type}
                placeholder={placeholder}
                id={id}
                onChange={onChange}
                name={name}
                {...register}
                defaultValue={defaultValue}
                value={value}
                disabled={disabled}
                autoComplete="off"
            />
            {errorMessage ? (
                <div className="error-message mt-8">{errorMessage}</div>
            ) : (
                ""
            )}
        </div>
    );
}

export default Input;